import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';
import { emailRecipientLabels  } from 'core/utils';

function ContactDepartmentEditTemplate({ contactDepartmentEditViewStore }) {
    const {
        contentLoading,
        form,
        contactDepartmentTypes
    } = contactDepartmentEditViewStore;

    const field = form.$('contactDepartmentTypeId');
    const isRequired = field && field.rules && field.rules.includes('required');

    return (
        <ApplicationEditLayout store={contactDepartmentEditViewStore}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="col col col-lrg-6 ">
                                    <div className='u-mar--bottom--med'>
                                         <BasicInput field={form.$('name')} />
                                    </div>
                                    <label className='form__group__label'>Type {isRequired && <span  className="validation__mark">*</span>}</label>
                                      {field.localizedError && (
                                        <div className="validation__message">
                                            <i className="u-icon u-icon--xsml u-icon--warning u-mar--right--tny"></i>
                                            {field.localizedError}
                                        </div>
                                    )}
                                    {contactDepartmentTypes && contactDepartmentTypes.length > 0 && (contactDepartmentTypes.map((item) => (
                                        <div key={item.id} className="form__check col u-mar--top--sml u-mar--left--sml">
                                            <input
                                                type="radio"
                                                className="input--radio"
                                                id={item.id}
                                                value={item.id}
                                                name="contactDepartmentTypeId"
                                                checked={form.$('contactDepartmentTypeId').value === item.id}
                                                onChange={() => form.$('contactDepartmentTypeId').set(item.id)}
                                            />
                                            <label htmlFor={item.id}>
                                                {item.name}
                                            </label>
                                        </div>
                                    )))}
                                </div>
                                <div className="col col-lrg-6">
                                    <label className='form__group__label'>Email Settings</label>
                                    <div className="u-mar--bottom--sml card card--settings">
                                        {renderEmailSettings(form)}
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                 </div>
            </Content>
        </ApplicationEditLayout>
    )
}

ContactDepartmentEditTemplate.propTypes = {
    contactDepartmentEditViewStore: PropTypes.object
};

function renderEmailSettings(form) {
 
    return emailRecipientLabels.map(({ name, label }) => {
        const emailField = form.$(name);

        return (
            <div key={name} className="card--settings--inner">
                <div className='btn--toggled__label'>{label}</div>
                <div className='btn--toggled__wrap'>
                    {['To', 'CC', ''].map((val, index) => (
                        <button
                            key={index}
                            type="button"
                            className={`btn btn--toggled ${
                                emailField.value === val ? 'btn--primary' : ''
                            }`}
                            onClick={() => emailField.set(val)}
                        >
                            {val === '' ? <i className="u-icon u-icon--sml u-icon--inactive--toggle"></i> : val}
                        </button>
                    ))}
                </div>
            </div>
        );
    });
}

export default defaultTemplate(ContactDepartmentEditTemplate);
